import moment from 'moment'
import MedicalExpertiseDisability from './MedicalExpertiseDisability'
import { parseDate } from './utils'

export default class Disability {
	static fromJSON(json) {
		return new Disability(json.disabilityByDays, json.disabilityPeriods)
			.withGroupedCount(json)
			.withStartEndDate(json.disabilityByDays)
	}

	constructor(byDays, byExpertise) {
		this.byDays = byDays
		this.byExpertise = Object.keys(byExpertise).map((expertise) =>
			MedicalExpertiseDisability.fromJSON({
				disabilities: byExpertise[expertise],
				expertise,
			})
		)
	}

	withGroupedCount(raw) {
		const distinctValueCounts = Array.from(
			new Set(Object.values(raw.disabilityByDays))
		)
			.map((value) => ({
				value,
				count: Object.values(raw.disabilityByDays).filter(
					(v) => v === value
				).length,
			}))
			.map((item) => ({
				rate: `${item.value.split('-')[0]}%`,
				disabilityId: item.value.split('-')[1],
				count: item.count,
			}))

		this.byRate = distinctValueCounts.filter(
			(item) => item.disabilityId !== 'ND'
		)

		return this
	}

	withStartEndDate(byDays) {
		const daysKeys = Object.keys(byDays).sort(
			(a, b) => moment(a).valueOf() - moment(b).valueOf()
		)

		this.startDate = parseDate(daysKeys[0])
		this.endDate = parseDate(daysKeys[daysKeys.length - 1])

		return this
	}
}
